const navigation = () => {
  const toggleBtn = document.querySelector(".js-navigation-toggler");
  const nav = document.querySelector(".js-navigation");

  const primaryMenu = document.querySelector(".primary-menu");

  const subMenus = document.querySelectorAll(".sub-menu");

  const menus = Array.from(primaryMenu.children);

  const backToTop = document.querySelector(".back-to-top");

  if (!toggleBtn) {
    return;
  }

  toggleBtn.addEventListener("click", (e) => {
    toggleBtn.classList.toggle("open");
    nav?.classList.toggle("open");
  });

  subMenus.forEach((menu, index) => {
    menu.addEventListener("mouseleave", () => {
      if (window.innerWidth > 1279) {
        menu.classList.remove("active");
        menus[index].classList.remove("active");
      }
    });
  });

  menus.forEach((menu) => {
    menu.addEventListener("click", () => {
      menus.forEach((m) => {
        if (menu != m) {
          m.classList.remove("active");
          m.querySelector(".sub-menu")?.classList.remove("active");
        }
      });
      menu.classList.toggle("active");
      menu.querySelector(".sub-menu")?.classList.toggle("active");
    });
    menu.addEventListener("mouseenter", () => {
      if (window.innerWidth > 1279) {
        menus.forEach((m) => {
          if (menu != m) {
            m.classList.remove("active");
            m.querySelector(".sub-menu")?.classList.remove("active");
          }
        });
        menu.classList.add("active");
        menu.querySelector(".sub-menu")?.classList.add("active");
      }
    });
    menu.addEventListener("mouseleave", () => {
      if (window.innerWidth > 1279) {
        menu.classList.remove("active");
        menu.querySelector(".sub-menu")?.classList.remove("active");
      }
    });
  });
  window.addEventListener("scroll", () => {
    menus.forEach((menu) => {
      menu.classList.remove("active");
      menu.querySelector(".sub-menu")?.classList.remove("active");
    });
  });
  if (backToTop) {
    backToTop.addEventListener("click", () => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    });
  }
};

export default navigation;
